import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesStore {
  private readonly _roles$: BehaviorSubject<Array<string> | null> = new BehaviorSubject<Array<string> | null>(null);
  private readonly STORAGE_KEY = 'currentUserRoles';

  constructor() {
    let initialValue = null;
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        initialValue = JSON.parse(stored);
      }
    } catch (e) {
      console.error('Error restoring User from sessionStorage', e);
    }
    
    this._roles$ = new BehaviorSubject<Array<string>|null>(initialValue);
  }

  get roles$(): Observable<Array<string> | null> {
    return this._roles$.asObservable();
  }

  set roles(roles: Array<string> | null) {
    if (roles) {
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(roles));
    } else {
      sessionStorage.removeItem(this.STORAGE_KEY);
    }
    this._roles$.next(roles);
  }
}
